class ResponsiveVideo {

  static init = (params) => {
    const selVideo = `${params.selVideo}:not(.is-initialized)`;
    const allVideos = document.querySelectorAll(selVideo);

    allVideos.forEach(video => {
      new ResponsiveVideo(video, params);
    })
  }



  constructor(video, params) {
    this.video = video;
    this.viewportMap = params.viewportMap;
    this.getCssCustomProperty = params.getCssCustomProperty;
    this.debounceThenExecute = params.debounceThenExecute;
    this.srcAttribute = this.video.querySelector('source');

    this.srcs = {};
    this.versions = [];
    this.missingVersions = [];
    this.bestGivenSource = '';

    this.markInitialized();

    if (!this.getSrcs()) return;

    this.createVersionArray();

    if (this.versions.length === 0) {
      this.handleMissingVersions();
      return;
    }

    this.getBestGivenSource();
    this.checkVersions();
    this.prepareVideo();
    this.watchResize();
  }



  getSrcs = () => {
    if (!this.video.dataset.srcs) return false;
    this.srcs = JSON.parse(this.video.dataset.srcs);
    return true;
  }



  createVersionArray = () => {
    Object.entries(this.viewportMap).forEach(entry => {
      this.versions.push(entry[1]);
      this.versions.push(`${entry[1]}Retina`)
    })

    this.versions = [...new Set(this.versions)];
  }



  getBestGivenSource = () => {
    this.versions.forEach(version => {
      if (this.srcs[version]) this.bestGivenSource = this.srcs[version];
    })
  }



  checkVersions = () => {
    this.versions.forEach(version => {
      if (!this.srcs[version]) {
        this.missingVersions.push(version);
      }
    })

    if (this.missingVersions.length > 0) this.createFallback();
  }



  createFallback = () => {
    this.missingVersions.forEach(version => {
      let newSource = this.getNextBestVersion(version);
      this.srcs[version] = newSource;
    })
  }



  getNextBestVersion = (version) => {
    const versionIndex = this.versions.indexOf(version);
    let newSource = '';

    for (let i = versionIndex + 1; i < this.versions.length; i++) {
      if (this.srcs[this.versions[i]]) newSource = this.srcs[this.versions[i]];
      break;
    }

    if (!newSource) newSource = this.bestGivenSource;
    return newSource;
  }



  prepareVideo = () => {
    const deviceData = this.getDeviceData();
    const viewport = deviceData.viewport;
    let density = deviceData.density;
    
    if (density === 'normal') density = '';
    if (density) density = this.capitalizeFirstLetter(density);

    const srcsKey = this.viewportMap[viewport] + density;
    const file = this.srcs[srcsKey];
    const type = file.split('.').pop();

    this.srcAttribute.src = file;
    this.srcAttribute.type = `video/${type}`;

    this.video.load();
    if (!this.video.controls) this.video.play();
  }



  markInitialized = () => {
    this.video.classList.add('is-initialized');
  }



  getDeviceData = () => {
    const scope = document.body;

    return {
      density: this.getCssCustomProperty(scope, '--density'),
      viewport: this.getCssCustomProperty(scope, '--vp-name')
    }
  }



  watchResize = () => {
    const resizeDebounced = this.debounceThenExecute(this.prepareVideo, 300);
    window.addEventListener('resize', () => {
      resizeDebounced();
    });
  }



  handleMissingSources = () => {
    console.warn('Video data missing! (path/types/iles required)');
    console.warn('Video initializing was stopped!');
  }



  handleMissingVersions = () => {
    console.warn('No valid video sources found!');
    console.warn('Video initializing was stopped!');
  }



  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
